import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./layers/Header";
import Footer from "./layers/Footer";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header /> 

      <section className="bg-white py-32 flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
        <h1 className="text-8xl font-bold text-[#1E0E62] mb-6">404</h1>
        <h2 className="text-3xl font-semibold text-[#1E0E62] mb-4">
          Page Not Found
        </h2>
        <p className="text-[#1E0E62]/70 mb-8 max-w-xl">
          Oops! The page you are looking for does not exist. It might have been moved or deleted.
        </p>
        <button
          className="bg-[#25DAC5] text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-[#1E0E62] transition"
          onClick={() => navigate("/")}
        >
          Go Back Home
        </button>
      </section>

      <Footer />
    </>
  );
};

export default NotFound;